import { UsuariosEffects } from './usuarios.effects';
import { UsuarioEffects } from './usuario.effects';
import { personalizationClientEffects } from './personalizationClient.effects';

export const effectsArray: any[] = [UsuariosEffects, UsuarioEffects, personalizationClientEffects];
